<template>
	<!-- <div id="app" style="background-color: #22A7FF;">
		<img src="./assets/logo.png">
	</div> -->
	<div id="app">
		{{Cookie()}}
		<router-view />
	</div>
</template>

<script>
	import Vue from "vue";
	export default {
		name: 'app',
		beforeDestroy: function() {
			this.close();
		},
		mounted: function() {
			this.load();
			Array.prototype.indexOf = function(val) {
				for (let i = 0; i < this.length; i++) {
					if (this[i] == val) return i;
				}
				return -1;
			};
			Array.prototype.remove = function(val) {
				let index = this.indexOf(val);
				if (index > -1) {
					this.splice(index, 1);
				}
			};
		},
		methods: {
			load() {
				this.loadP();
				// let value={
				// 	account: "zxnw",
				// 	password: "123456"
				// }
				// console.log(this.$store.state.main);
				// this.getuser();
				// console.log(this.$store.state.main);
			},
			close() {

			},
			getHeight() {
				this.$store.commit('width', window.innerWidth);
				this.$store.commit('height', window.innerHeight);
			},
			Cookie() {
				let value = { ...this.$route.query
					},
					isAuto = false;
				if (this.$route.query.token != null && this.$route.query.platform_id != null && this.$route.query.logout != null) {
					this.setCookie(this.config.token, this.$route.query.token, 3);
					this.setCookie(this.config.jdid, this.$route.query.platform_id, 3);
					this.setCookie(this.config.logout, this.$route.query.logout, 3);
					this.$router.push(this.$route.path);
				}
				if (this.$route.query.token != null) {
					this.setCookie(this.config.token, this.$route.query.token, 3);
					isAuto = true;
					delete value.token;
				}
				if (this.$route.query.base != null) {
					this.setCookie(this.config.jdid, this.$route.query.base, 3);
					isAuto = true;
					delete value.base;
				}
				if (isAuto) {
					this.$router.push({
						path: this.$route.path,
						query: value
					});
				}
				Vue.prototype.$store = this.$store;
				Vue.prototype.route = this.$route;
			}
		},
		created() {
			window.addEventListener('resize', this.getHeight);
			this.getHeight()
		},
		destroyed() {
			window.removeEventListener('resize', this.getHeight)
		}
	}
</script>

<style>
	.el-message-box {
		width: 350px !important;
	}

	body {
		margin: 0;
	}
</style>
